import { metricItems } from '@Compute/views/node-alert/constants'
import i18n from '@/locales'

// Linux capabilities（不带 CAP_ 前缀）
export const CAPABILITY_OPTIONS = [
  { value: 'AUDIT_WRITE', label: 'AUDIT_WRITE', description: i18n.t('compute.repo.cap.AUDIT_WRITE') },
  { value: 'BLOCK_SUSPEND', label: 'BLOCK_SUSPEND', description: i18n.t('compute.repo.cap.BLOCK_SUSPEND') },
  { value: 'CHOWN', label: 'CHOWN', description: i18n.t('compute.repo.cap.CHOWN') },
  { value: 'DAC_OVERRIDE', label: 'DAC_OVERRIDE', description: i18n.t('compute.repo.cap.DAC_OVERRIDE') },
  { value: 'FOWNER', label: 'FOWNER', description: i18n.t('compute.repo.cap.FOWNER') },
  { value: 'KILL', label: 'KILL', description: i18n.t('compute.repo.cap.KILL') },
  { value: 'MKNOD', label: 'MKNOD', description: i18n.t('compute.repo.cap.MKNOD') },
  { value: 'NET_ADMIN', label: 'NET_ADMIN', description: i18n.t('compute.repo.cap.NET_ADMIN') },
  { value: 'NET_BIND_SERVICE', label: 'NET_BIND_SERVICE', description: i18n.t('compute.repo.cap.NET_BIND_SERVICE') },
  { value: 'NET_RAW', label: 'NET_RAW', description: i18n.t('compute.repo.cap.NET_RAW') },
  { value: 'SETGID', label: 'SETGID', description: i18n.t('compute.repo.cap.SETGID') },
  { value: 'SETPCAP', label: 'SETPCAP', description: i18n.t('compute.repo.cap.SETPCAP') },
  { value: 'SETUID', label: 'SETUID', description: i18n.t('compute.repo.cap.SETUID') },
  { value: 'SYS_ADMIN', label: 'SYS_ADMIN', description: i18n.t('compute.repo.cap.SYS_ADMIN') },
  { value: 'SYS_CHROOT', label: 'SYS_CHROOT', description: i18n.t('compute.repo.cap.SYS_CHROOT') },
  { value: 'SYS_NICE', label: 'SYS_NICE', description: i18n.t('compute.repo.cap.SYS_NICE') },
  { value: 'SYS_PTRACE', label: 'SYS_PTRACE', description: i18n.t('compute.repo.cap.SYS_PTRACE') },
  { value: 'SYS_RESOURCE', label: 'SYS_RESOURCE', description: i18n.t('compute.repo.cap.SYS_RESOURCE') },
  { value: 'SYSLOG', label: 'SYSLOG', description: i18n.t('compute.repo.cap.SYSLOG') },
  { value: 'WAKE_ALARM', label: 'WAKE_ALARM', description: i18n.t('compute.repo.cap.WAKE_ALARM') },
]

const NETIO_GROUP_BY_TAG = ['interface', 'host_interface', 'ip', 'mac']

// 容器主机监控数据
export const POD_MONITOR = [
  {
    name: 'pod_cpu',
    label: i18n.t('compute.text_523'),
    seleteItem: 'usage_rate',
    fromItem: 'pod_cpu',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_cpu.usage_rate'].key,
  },
  {
    name: 'pod_mem',
    label: i18n.t('compute.text_518'),
    seleteItem: 'usage_rate',
    fromItem: 'pod_mem',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_mem.usage_rate'].key,
  },
  /* {
    name: 'pod_mem',
    label: i18n.t('compute.container.monitor.pod_mem_used'),
    seleteItem: 'working_set_bytes',
    fromItem: 'pod_mem',
    unit: 'B',
    transfer: 1024,
    metric: metricItems['pod_mem.working_set_bytes'].key,
  }, */
  /* {
    name: 'pod_volume',
    label: i18n.t('compute.container.monitor.pod_volume_used_total'),
    seleteItem: 'used,total',
    as: i18n.t('compute.container.monitor.used_total'),
    fromItem: 'pod_volume',
    unit: 'B',
    transfer: 1024,
    // metric: metricItems['pod_volume.total'].key,
    groupBy: ['mount_path', 'type'],
  }, */
  {
    name: 'pod_volume',
    label: i18n.t('compute.container.monitor.pod_volume_used_percent'),
    seleteItem: 'used_percent',
    fromItem: 'pod_volume',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_volume.used_percent'].key,
    groupBy: ['mount_path', 'type'],
  },
  {
    name: 'pod_volume',
    label: i18n.t('compute.container.monitor.pod_volume_inodes_used_percent'),
    seleteItem: 'inodes_used_percent',
    fromItem: 'pod_volume',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_volume.inodes_used_percent'].key,
    groupBy: ['mount_path', 'type'],
  },
  {
    name: 'pod_diskio',
    label: i18n.t('compute.container.monitor.pod_diskio_read_Bps'),
    seleteItem: 'read_Bps',
    fromItem: 'pod_diskio',
    unit: 'bps',
    transfer: 1024,
    metric: metricItems['pod_diskio.read_Bps'].key,
    groupBy: ['device'],
  },
  {
    name: 'pod_diskio',
    label: i18n.t('compute.container.monitor.pod_diskio_write_Bps'),
    seleteItem: 'write_Bps',
    fromItem: 'pod_diskio',
    unit: 'bps',
    transfer: 1024,
    metric: metricItems['pod_diskio.write_Bps'].key,
    groupBy: ['device'],
  },
  {
    name: 'pod_netio',
    label: i18n.t('compute.container.monitor.pod_netio_bps_recv'),
    seleteItem: 'bps_recv',
    fromItem: 'pod_netio',
    unit: 'bps',
    transfer: 1024,
    metric: metricItems['pod_netio.bps_recv'].key,
    groupBy: NETIO_GROUP_BY_TAG,
  },
  {
    name: 'pod_netio',
    label: i18n.t('compute.container.monitor.pod_netio_bps_sent'),
    seleteItem: 'bps_sent',
    fromItem: 'pod_netio',
    unit: 'bps',
    transfer: 1024,
    metric: metricItems['pod_netio.bps_sent'].key,
    groupBy: NETIO_GROUP_BY_TAG,
  },
  /* {
    name: 'pod_netio',
    label: i18n.t('compute.container.monitor.pod_netio_pps_sent'),
    seleteItem: 'pps_sent',
    fromItem: 'pod_netio',
    transfer: 1,
    unit: 'pps',
    metric: metricItems['pod_netio.pps_sent'].key,
    groupBy: NETIO_GROUP_BY_TAG,
  },
  {
    name: 'pod_netio',
    label: i18n.t('compute.container.monitor.pod_netio_pps_recv'),
    seleteItem: 'pps_recv',
    fromItem: 'pod_netio',
    transfer: 1,
    unit: 'pps',
    metric: metricItems['pod_netio.pps_recv'].key,
    groupBy: NETIO_GROUP_BY_TAG,
  }, */
  {
    name: 'pod_process',
    label: i18n.t('compute.container.monitor.pod_process_process_count'),
    seleteItem: 'process_count',
    fromItem: 'pod_process',
    unit: '',
    metric: metricItems['pod_process.process_count'].key,
  },
  {
    name: 'pod_process',
    label: i18n.t('compute.container.monitor.pod_process_fd_count'),
    seleteItem: 'fd_count',
    fromItem: 'pod_process',
    unit: '',
    metric: metricItems['pod_process.fd_count'].key,
  },
  {
    name: 'pod_gpu',
    label: i18n.t('compute.container.monitor.pod_gpu_mem_util'),
    seleteItem: 'mem_util',
    fromItem: 'pod_gpu',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_gpu.mem_util'].key,
  },
  {
    name: 'pod_gpu',
    label: i18n.t('compute.metric.gpu_field.utilization_gpu'),
    seleteItem: 'gpu_util',
    fromItem: 'pod_gpu',
    unit: '%',
    transfer: 1,
    metric: metricItems['pod_gpu.gpu_util'].key,
  },
]
